<template>
  <header class="site-header">
    <a class="skip" href="#conteudo">Pular para o conteúdo</a>
    <div class="container masthead">
      <router-link to="/" class="brand brand-light" aria-label="GASS GROUP — Home">
        <img
          src="/site-assets/layouts/gass-groupv1-0110/assets/img/logo-gass-50-anos.png"
          alt="GASS GROUP"
          width="235"
          height="95"
        />
      </router-link>
      <div v-if="text('iti_textobtn1') || text('iti_textobtn2')" class="header-info">
        <span class="header-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="8" />
            <path d="M12 7v5l3 2M18 4l2 2" />
          </svg>
        </span>
        <div>
          <p class="info-label">{{ text('iti_textobtn1') }}</p>
          <p>{{ text('iti_textobtn2') }}</p>
        </div>
      </div>
      <div v-if="text('iti_textobtn3') || text('iti_textobtn4')" class="header-info">
        <span class="header-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path
              d="M5 3l4 1 1 5-2 2a15 15 0 0 0 5 5l2-2 5 1 1 4c-1 3-5 2-8 0C8 16 4 12 3 7c-.5-2 0-3 2-4zM14 4a7 7 0 0 1 6 6M14 8a3 3 0 0 1 2 2"
            />
          </svg>
        </span>
        <div>
          <p class="info-label">{{ text('iti_textobtn3') }}</p>
          <ContentLink v-if="whatsapp" :to="whatsapp" class="text-link">{{
            text('iti_textobtn4')
          }}</ContentLink>
        </div>
      </div>
      <button
        type="button"
        class="menu-toggle"
        aria-controls="navegacao"
        :aria-expanded="open"
        @click="open = !open"
      >
        Menu
      </button>
    </div>
    <div class="nav-band">
      <div class="container nav-inner">
        <nav
          id="navegacao"
          :class="{ 'is-open': open }"
          aria-label="Navegação principal"
          @keydown.esc="open = false"
        >
          <ul>
            <li v-for="group in navigation" :key="group.chave">
              <router-link :to="path(group.chave)" @click="open = false">{{
                group.nome
              }}</router-link>
            </li>
          </ul>
        </nav>
        <router-link to="/contato" class="nav-cta" @click="open = false">
          Fale com um especialista
          <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            width="18"
            height="18"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
          >
            <path d="M6 18L18 6M7 6h11v11" />
          </svg>
        </router-link>
      </div>
    </div>
    <p v-if="error" class="container" role="status">
      Informações de contato temporariamente indisponíveis.
    </p>
  </header>
</template>
<script>
import { groups, screens, groupPath } from '@/data/institutionalBlueprint';
import { loadScreens, contentValue, plainText } from '@/services/contentApi';
import ContentLink from './ContentLink.vue';
import { whatsappLink } from '@/services/phoneLinks';
export default {
  name: 'PageHeader',
  components: { ContentLink },
  data: () => ({ record: {}, open: false, error: false }),
  computed: {
    navigation() {
      return ['home', 'o-grupo', 'solucoes', 'setores', 'insights', 'contato']
        .map((key) => groups.find((group) => group.chave === key))
        .filter(Boolean);
    },
    whatsapp() {
      return whatsappLink(this.text('iti_textobtn4'));
    },
  },
  watch: {
    '$route.path'() {
      this.open = false;
    },
  },
  async created() {
    const result = await loadScreens([screens['home-cabecalho']]);
    this.record = result.data['home-cabecalho']?.[0] || {};
    this.error = result.errors.length > 0;
    await this.$nextTick();
    window.__HEADER_READY__ = true;
  },
  methods: {
    path: groupPath,
    text(field) {
      return plainText(contentValue(this.record, field));
    },
  },
};
</script>
